import React from 'react';
// react-router-dom imports removed since they are unused
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { Layout } from '../../components/Layout';
import { PublicLayout } from './PublicLayout';
import { useAuth } from '../../contexts/AuthContext';

/** Picks sidebar layout when logged in, public header when guest. */
export const AppointmentsRouteLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    );
  }

  return <PublicLayout />;
};
